var styles = {"previewItem":"MediaGallery-module_previewItem__fejRw"};

export { styles as default };
